import pod from "./pod";

export default {
  namespaced: true,
  modules: {
    pod,
  },
};
